import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import loginlogo from "../Login/LoginLogo.png";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Api } from "../../BackendApi/api";
import { APP_VERSION } from "../Version Provider/VersionConfig";
import ConfirmPopup from "../../Component/ConfirmPopup/ConfirmPopup";

const Login = () => {

    const navigate = useNavigate();

    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const [mobileError, setMobileError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [loginError, setLoginError] = useState("");

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
            navigate("/admin/dashboard");
        }
    }, [navigate]);

    const validateMobile = (value) => {
        if (!value) return "Mobile number is required";
        if (!/^\d{10}$/.test(value))
            return "Enter a valid 10-digit mobile number";
        return "";
    };

    const validatePassword = (value) => {
        if (!value) return "Password is required";
        if (value.length < 6) return "Password must be at least 6 characters";
        return "";
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        const mobileErr = validateMobile(mobile);
        const passwordErr = validatePassword(password);

        if (mobileErr || passwordErr) {
            setMobileError(mobileErr);
            setPasswordError(passwordErr);
            return;
        }

        try {

            const response = await axios.post(Api.adminLogin, {
                VersionCode: versionCode,
                Mobile: mobile,
                Password: password,
            });

            if (
                response.data.status === 0 &&
                response.data.message &&
                response.data.message.toLowerCase().includes("version")
            ) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });
                return;
            }

            if (response.data && response.data.status === 1) {

                const userData =
                    response.data.data && response.data.data.length > 0
                        ? response.data.data[0]
                        : null;

                if (userData) {

                    localStorage.setItem(
                        "authToken",
                        userData.AuthToken || ""
                    );

                    localStorage.setItem(
                        "currentUser",
                        JSON.stringify(userData)
                    );
                }

                navigate("/admin/dashboard");

            } else {

                setLoginError(
                    response.data.message || "Invalid credentials"
                );
            }

        } catch (error) {

            console.error("Login error:", error);

            setPopup({
                show: true,
                message: "Something went wrong. Please try again.",
                type: "error",
            });
        }
    };

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    return (
        <div className="body">
            <div className="admin-login-container">

                <img src={loginlogo} alt="" />

                <form onSubmit={handleSubmit}>

                    <div className="form-group">
                        <label>Mobile Number</label>

                        <input
                            type="text"
                            value={mobile}
                            onChange={(e) => {
                                setMobile(e.target.value);
                                setMobileError("");
                            }}
                            placeholder="Enter mobile number"
                        />

                        {mobileError && <p className="error">{mobileError}</p>}
                    </div>

                    <div className="form-group password-wrapper">

                        <label>Password</label>

                        <div className="input-container">

                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setPasswordError("");
                                }}
                                placeholder="Enter password"
                            />

                            <span
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>

                        </div>

                        {passwordError && (
                            <p className="error">{passwordError}</p>
                        )}

                    </div>

                    {loginError && <p className="error">{loginError}</p>}

                    <button type="submit" className="btn">
                        Login
                    </button>

                </form>
                <p style={{marginTop:"10px",color:"#704A94"}}>Version {versionCode}</p>

            </div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default Login;